import axios from "../http";
import http from "../http";

export function useCampaign() {
  const myCampaigns = (params) => axios.get('/api/my-campaigns', {params});
  const getCampaigns = (params) => axios.get('/api/campaigns', {params});
  const getCampaign = id => axios.get(`/api/campaigns/${id}`);
  const getCreators = id => axios.get(`/api/campaigns/${id}/creators`);
  const getDetails = (id) => axios.get(`/api/campaigns/${id}/details`);
  const getTodos = (id) => axios.get(`/api/campaigns/${id}/todos`);
  const getApplications = (id) => axios.get(`/api/campaigns/${id}/applications`);
  const calculateTimeline = (params) => axios.get(`/api/campaigns/calculate-timeline`, {params});
  const getShipmentsByCampaign = async (campaign, user) => axios.get(`/api/campaigns/${campaign}/get-user-shipment/${user}`);

  const getMessages = (campaignId, userId) => http.get(`/api/campaigns/${campaignId}/messages/${userId}`);
  const createMessage = (campaignId, userId, params) => http.post(`/api/campaigns/${campaignId}/messages/${userId}`, params);

  const create = (params) => axios.post('/api/campaigns', params);
  const update = (id, params) => axios.post(`/api/campaigns/${id}`, params);
  const setDelete = (id) => axios.get(`/api/campaigns/${id}/delete`);
  const checkout = id => axios.post(`/api/campaigns/${id}/checkout`);
  const checkoutCreators = (id, params) => axios.post(`/api/campaigns/${id}/checkout-creators`, params);
  const draft = (params) => axios.post('/api/campaigns/draft', params);

  // GENERATE SCRIPTS VIA CHAT GPT
  const createScripts = (params) => axios.post('/api/createCampaignScripts', params);

  const validateInfo = (params) => axios.post('/api/campaigns/validate-info', params);
  const prepareToSave = (campaignData) => {
    return {
      ...campaignData,
      products: campaignData.products.map(({id}) => id),
      age: campaignData.age.map(({id}) => id),
      gender: campaignData.gender.map(({id}) => id),
    };
  }

  const isStatusDraft = (status) => status === 'DRAFT';
  const isStatusActive = (status) => status === 'ACTIVE';

  const isCreatorSubmittedAdStatusApproved = ({ creator_statuses }) => creator_statuses.includes('SUBMITTED_AD_APPROVED');
  const isCreatorSubmittedAdStatusRevision = ({ creator_statuses }) => creator_statuses.includes('SUBMITTED_AD_REVISION');
  const isCreatorSubmittedAdStatusPending = ({ creator_statuses }) => creator_statuses.includes('SUBMITTED_AD_PENDING');
  const isCreatorSubmittedAdStatusDraft = ({ creator_statuses }) => creator_statuses.includes('SUBMITTED_AD_DRAFT');

  const isCreatorApplicationStatusApproved = ({ creator_statuses }) => creator_statuses.includes('APPLICATION_APPROVED');
  const isCreatorApplicationStatusPending = ({ creator_statuses }) => creator_statuses.includes('APPLICATION_PENDING');
  const isCreatorApplicationStatusRejected = ({ creator_statuses }) => creator_statuses.includes('APPLICATION_REJECTED');

  const isCreatorShipmentStatusNotCreated = ({ creator_statuses }) => creator_statuses.includes('SHIPMENT_NOT_CREATED');
  const isCreatorShipmentStatusPending = ({ creator_statuses }) => creator_statuses.includes('SHIPMENT_PENDING');
  const isCreatorShipmentStatusShipped = ({ creator_statuses }) => creator_statuses.includes('SHIPMENT_SHIPPED');
  const isCreatorShipmentStatusDelivered = ({ creator_statuses }) => creator_statuses.includes('SHIPMENT_DELIVERED');
  const isCreatorShipmentStatusUndelivered = ({ creator_statuses }) => creator_statuses.includes('SHIPMENT_UNDELIVERED');

  const getComputedCampaignStatus = (object) => {
    if (isCreatorSubmittedAdStatusPending(object)) return {text: 'Waiting for approval', class: 'waiting-approval',};
    if (isCreatorSubmittedAdStatusApproved(object)) return {text: 'Approved', class: 'approved',};
    if (isCreatorSubmittedAdStatusRevision(object)) return {text: 'Edits needed', class: 'revision',};
    if (isCreatorSubmittedAdStatusDraft(object)) return {text: 'Draft', class: 'draft',};

    if (isCreatorApplicationStatusApproved(object)) return {text: 'Application approved', class: 'approved',};
    if (isCreatorApplicationStatusPending(object)) return {text: 'Pending', class: 'pending',};
    if (isCreatorApplicationStatusRejected(object)) return {text: 'Rejected', class: 'rejected',};

    if (isCreatorShipmentStatusNotCreated(object)) return {text: 'Rejected', class: 'rejected',};
  }

  const getComputedCreatorStatus = (object) => {
    if (isCreatorSubmittedAdStatusPending(object)) return {text: 'Approval Needed',};
    if (isCreatorShipmentStatusShipped(object)) return {text: 'Product shipped',};
    if (isCreatorSubmittedAdStatusApproved(object)) return {text: 'Approved',};

    return {text: 'Shooting',};
  }


  return {
    myCampaigns,
    getCampaigns,
    getCreators,
    getTodos,
    getApplications,
    getShipmentsByCampaign,
    create,
    draft,
    prepareToSave,
    isStatusDraft,
    getDetails,
    getCampaign,
    validateInfo,
    update,
    setDelete,
    checkout,
    checkoutCreators,
    isStatusActive,
    calculateTimeline,
    getMessages,
    createMessage,

    getComputedCampaignStatus,
    getComputedCreatorStatus,

    isCreatorSubmittedAdStatusApproved,
    isCreatorSubmittedAdStatusRevision,
    isCreatorSubmittedAdStatusPending,
    isCreatorSubmittedAdStatusDraft,

    isCreatorApplicationStatusApproved,
    isCreatorApplicationStatusPending,
    isCreatorApplicationStatusRejected,

    isCreatorShipmentStatusNotCreated,
    isCreatorShipmentStatusPending,
    isCreatorShipmentStatusShipped,
    isCreatorShipmentStatusDelivered,
    isCreatorShipmentStatusUndelivered,

    createScripts,
  }
}
